var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialUpLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 338,
    height: 211,
    viewBox: "0 0 338 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Tracciato_1557",
    x: 0,
    y: 0,
    width: 219,
    height: 27,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rettangolo_474",
    x: 0,
    y: 9,
    width: 338,
    height: 202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_981",
    "data-name": "Raggruppa 981",
    transform: "translate(-1425 -1351)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1425, 1351)",
    filter: "url(#Tracciato_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1557-2",
    "data-name": "Tracciato 1557",
    d: "M221,22H70.92L63.5,13l-7.792,9H221Z",
    transform: "translate(-17 -13)",
    fill: "#6466f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1425, 1351)",
    filter: "url(#Rettangolo_474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_474-2",
    "data-name": "Rettangolo 474",
    width: 320,
    height: 184,
    rx: 9,
    transform: "translate(3 9)",
    fill: "#6466f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialUpLeft);
export default __webpack_public_path__ + "static/media/tutorial-up-left.d1add27db34895692be4081e36be735f.svg";
export { ForwardRef as ReactComponent };